// extracted by mini-css-extract-plugin
export default {"nativeview":"nativeview_ec36730d80f1bbf96f54"};